export default __webpack_public_path__ + "static/media/crypto-market.fd9a40f4.png";